import { cn } from '@/lib/utils'
import { cva, type VariantProps } from 'class-variance-authority'
import React from 'react'

export interface DividerProps extends React.HTMLAttributes<HTMLHRElement>, VariantProps<typeof dividerVariants> {}

const dividerVariants = cva('h-px border-0 bg-slate-900/10', {
  variants: {
    size: {
      zero: '',
      sm: 'my-4',
      default: 'my-6',
      lg: 'my-8',
      xl: 'my-12 md:my-20',
    },
  },
  defaultVariants: {
    size: 'default',
  },
})

const Divider = ({ className, size }: DividerProps) => {
  return <hr className={cn(dividerVariants({ size }), className)} />
}

export default Divider
